import Papa from 'papaparse';

export const downloadCSVFile = async (downloadURL) => {
  const res = await fetch(downloadURL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (res.ok) {
    const data = await res.blob();
    return data;
  }
};

export const getParsedCsvFile = (file): Promise<Record<string, string>[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        resolve(result.data);
      },
      error: (error) => {
        console.error('Error parsing CSV file:', error);
        reject(error);
      },
    });
  });
};

export const uploadCsvFile = async ({ url, contentType, file }) => {
  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  });

  return res;
};
